import { collection, query as fbQuery, limit, onSnapshot, orderBy, where } from "firebase/firestore";
import { db } from "./firebase.utils";

// Admin-only reads. League data helpers live in getDataFromDb.js.

export async function getCollectionFromDb(e) {
    let collectionRef = collection(db, e.collection);
    const unsubscribe = onSnapshot(collectionRef, docs => {
        docs.forEach(doc => {
            e.callback(doc.data())
        });
    });
    e.handleListener(unsubscribe);
}

export async function getAllUsersFromDb(e) {
    const usersRef = fbQuery(collection(db, `users`), where('status', '==', 'active'));
    const unsubscribe = onSnapshot(usersRef, docs => {
        docs.forEach(doc => {
            e.callback(doc.data());
        });
    })
    e.receiveListener(unsubscribe);
}

// Activity log (Firestore `activity`, kept 90 days). Newest first; optional
// e.appId and e.type filters. Each filter combination has a composite index
// in bball_01/firestore.indexes.json.
export async function getActivityLogs(e) {
    const filters = [];
    if (e.appId) filters.push(where('user', '==', e.appId));
    if (e.type) filters.push(where('type', '==', e.type));
    const logsRef = fbQuery(collection(db, 'activity'), ...filters, orderBy('ts', 'desc'), limit(100));

    const unsubscribe = onSnapshot(logsRef, docs => {
        docs.forEach(doc => {
            e.callback({...doc.data(), id: doc.id});
        });
    });
    e.receiveListener(unsubscribe);
}

export async function getBugReports(e) {
    let bugsRef;

    if (e.onlyActive) {
        bugsRef = fbQuery(collection(db, `bugReports`), where('status', '==', 'active'))
    } else {
        bugsRef = fbQuery(collection(db, `bugReports`));
    }
    const unsubscribe = onSnapshot(bugsRef, docs => {
        docs.forEach(doc => {
            const data = doc.data();
            e.callback(data);
        });
    })
    e.receiveListener(unsubscribe);
}
